(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(el) {
      if (el.dataset.wbCollageReady === 'true') return;
      el.dataset.wbCollageReady = 'true';

      // reveal on first entry, then stop observing (no replay on scroll-back)
      if (el.classList.contains('wb-collage--animated') && !REDUCED.matches) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('wb-collage--in');
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
        );
        io.observe(el);
      } else {
        el.classList.add('wb-collage--in');
      }

      if (el.dataset.parallax !== 'true' || REDUCED.matches) return;

      const strength = parseFloat(
        getComputedStyle(el).getPropertyValue('--wb-parallax-strength')
      ) || 0;
      if (!strength) return;

      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        // -1 (section entering from below) .. 1 (leaving at the top)
        const progress =
          (window.innerHeight / 2 - (rect.top + rect.height / 2)) /
          ((window.innerHeight + rect.height) / 2);
        el.style.setProperty('--wb-par', (progress * strength * 40).toFixed(2));
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }

    function init(root) {
      (root || document).querySelectorAll('.wb-collage').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
